import { Input, ViewChild } from '@angular/core';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Article } from '../../../../facturation/shared/classes/article';
import { CategorieArticle } from '../../../../facturation/shared/classes/categorie-article';
import { TypeQuantite } from '../../../../facturation/shared/classes/type-quantite';
import { ArticleService } from '../../../../facturation/shared/services/article.service';
import { TRANSLATE } from '../../../classes/translatable';
import { AlertService } from '../../../services/alert.service';
import { ConfigurationService } from '../../../../configuration/shared/services/configuration.service';
import { FactureClientService } from '../../../../facturation/shared/services/facture-client.service';
import { ClasseComptable } from '../../../../configuration/shared/classes/classeComptable';
import { ConfigurationClientService } from '../../../../core/services/configuration-client.service';
import { ConfigurationClient } from '../../../../core/shared/classes/configuration-client';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-admin-article-detail',
  templateUrl: './admin-article-detail.component.html',
  styleUrls: ['./admin-article-detail.component.css']
})
export class AdminArticleDetailComponent implements OnInit {

  @Input() article: Article = null;
  @Input() maxArticles: number = null;
  @Output() changeArticle: EventEmitter<Article> = new EventEmitter();
  @Output() toggleArticle: EventEmitter<Article> = new EventEmitter();

  categories: CategorieArticle[] = [];
  typesQuantites: TypeQuantite[] = [];
  listArticles: any[] = [];
  displayedColumns = ['select', 'art_code', 'art_libelle', 'art_compte_comptable_societe'];
  compteComptableSociete: any;
  selectedArticles: any[] = [];
  classeComptable: any = [];
  compteComptableParDefaut: ClasseComptable;
  changedArticles: any[] = [];
  configClient: ConfigurationClient = null;
  codeJournalExact: string;
  classesComptablesForm: FormGroup;

  @ViewChild('closeModal') closeModal;

  constructor(
    protected articleService: ArticleService,
    protected alertService: AlertService,
    private configService: ConfigurationService,
    private factureService: FactureClientService,
    private configClientService: ConfigurationClientService
  ) { }

  ngOnInit() {
    this.fetchCategories();
    this.fetchTypesQuantites();
    this.initFormGroup();
    this.configClientService.getConfiguration().subscribe(response => {
      this.configClient = response.data;
      this.codeJournalExact = this.configClient.cci_code_journal_exact;
      this.classesComptablesForm.controls['codeJournal'].setValue(this.codeJournalExact);  
    });
    this.configService.getClasseComptable().subscribe(response => {
      if (response.status === 200) {
        response.data.forEach(element => {
          this.classeComptable.push(element);
          if (element.classe_principale == 1) {
            this.compteComptableParDefaut = element;
            this.setCompteComptableParDefaut();
          }
        }); 
      }
    })
  }

  ngOnChanges() {
    const params = {currentPage: 1, maxItemPerPage: this.maxArticles};
    this.articleService.getList(params).subscribe(response => {
      this.listArticles = response.data.data;
    })
  }

  initFormGroup() {
    this.classesComptablesForm = new FormGroup({
      codeJournal: new FormControl(this.codeJournalExact, Validators.maxLength(6)),
      compteComptableSociete: new FormControl(this.compteComptableSociete)
    });
  }

  getCompteComptable() {
    return this.compteComptableParDefaut;
  }

  setCompteComptableParDefaut() {
    this.compteComptableSociete = this.compteComptableParDefaut.numero_compte;
  }

  applyCompteComptable() {
    this.compteComptableSociete = this.classesComptablesForm.get('compteComptableSociete').value;
  
    this.listArticles.forEach(currentArticle => {
      if (this.selectedArticles.indexOf(currentArticle.art_id) > -1) {
        currentArticle.art_compte_comptable_societe = this.compteComptableSociete;
        this.changedArticles.push(currentArticle);
      }
    });
    this.alertService.warn('La classe comptable a bien été appliquée aux articles sélectionnés. Validez pour enregistrer les modifications.');
  }

  checkArticleToggle(article, isChecked) {
    if (isChecked) {
      this.selectedArticles.push(article);
    } else {
      this.selectedArticles.splice(this.selectedArticles.indexOf(article));
    }
  }

  fetchCategories() {
    this.articleService.getCategorieList().subscribe(response => {
      if (response.status === 200 ) {
        this.categories = [];
        response.data.map((cat: CategorieArticle) => {
          this.categories.push(new CategorieArticle(cat));
        });
      } else {
        this.alertService.error(response.message);
      }
    });
  }

  fetchTypesQuantites() {
    this.articleService.getTypeQuantiteList().subscribe(response => {
      if (response.status === 200 ) {
        this.typesQuantites = [];
        response.data.map((typ: TypeQuantite) => {
          this.typesQuantites.push(new TypeQuantite(typ));
        });
      } else {
        this.alertService.error(response.message);
      }
    });
  }

  onSaveClasseComptable() {
    if (this.classesComptablesForm.get('codeJournal') && this.classesComptablesForm.get('codeJournal').errors) {
      let actualLength = this.classesComptablesForm.get('codeJournal').errors.maxlength.actualLength;
      let requiredLength = this.classesComptablesForm.get('codeJournal').errors.maxlength.requiredLength;
      this.alertService.error('Vous avez saisi ' + actualLength + ' caractères pour le code journal. La limite est de ' + requiredLength + ' caractères maximum.');
    } else {
      this.codeJournalExact = this.classesComptablesForm.get('codeJournal').value;
      if (this.configClient.cci_code_journal_exact != this.codeJournalExact) {
        this.configClient.cci_code_journal_exact = this.codeJournalExact;
        this.configClientService.update(this.configClient).subscribe(response => {
          if (response.status !== 200) {
            hasError = true;
          }
        })
      }

      let hasError = false;
      this.listArticles.forEach(article => {
        this.articleService.update(article.art_id, new Article(article)).subscribe(response => {
          if (response.status !== 200) {
            hasError = true;
          }
        })
      });
  
      this.factureService.updateFcdClasseByArticleList(this.changedArticles).subscribe(response => {
        if (response.status !== 200) {
          hasError = true;
        }
        this.changedArticles = [];
      });
  
      if (!hasError) {
        this.alertService.success(TRANSLATE(`Classes comptables modifiées avec succès`));
      }
    }
  }

  onSave() {
    const validation = this.article.checkIsValid();
    let hasError = false;

    if (!validation.valid) {
      this.alertService.error(`${validation.fields.length > 1 ? TRANSLATE('Champs requis :') : TRANSLATE('Champ requis :')} ${validation.fields.join(', ')}`);
      return;
    }

    if (this.article.art_id > 0) {
      this.articleService.update(this.article.art_id, this.article).subscribe(response => {
        if (response.status === 200) {
          this.alertService.success(TRANSLATE(`Article enregistré avec succès`));
          this.closeModal.nativeElement.click();
          this.changeArticle.emit(this.article);

          this.factureService.updateFcdClasseByArticle(this.article).subscribe(response => {
            if (response.status !== 200) {
              hasError = true;
            }
          });
        } else {
          this.alertService.error(response.message);
        }
      });
    } else {
      this.articleService.create(this.article).subscribe(response => {
        if (response.status === 200) {
          this.alertService.success(TRANSLATE(`Article créé avec succès`));
          this.closeModal.nativeElement.click();
          this.changeArticle.emit(this.article);
        } else {
          this.alertService.error(response.message);
        }
      });
    }
  }

  toggleDetail() {
    this.toggleArticle.emit(null);
  }

}
